import React from 'react';
import { Link } from "react-router-dom";
import VisasLogo from '../static/images/visas.png'

export default function Footer() {
    return (
        <div className="legal">
            <div className="d-block">2018 © Santo Domingo Country Club</div>
            <ul>
                <li><Link to="/politica-privacidad">Política de Privacidad</Link></li>
                <li><Link to="/politica-devolucion">Política de Devolución</Link></li>
                <li><Link to="/politica-transmision">Política de Transmisión</Link></li>
            </ul>
            <img src={VisasLogo} alt="Tarjetas que aceptamos" style={{height:'37px'}}/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Layouts/Footer.js